module.exports = __webpack_public_path__ + "img/vertical_3_4_8011.365d564f.png";